"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var usePreferDarkMode = function () {
    var _a = react_1.useState(window.matchMedia("(prefers-color-scheme: dark)").matches), darkMode = _a[0], setDarkMode = _a[1];
    react_1.useEffect(function () {
        var mediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
        setDarkMode(mediaQueryList.matches);
        var handlePreferedColorSchemeChange = function (e) { return setDarkMode(e.matches); };
        mediaQueryList.addListener(handlePreferedColorSchemeChange);
        return function () { return mediaQueryList.removeListener(handlePreferedColorSchemeChange); };
    }, []);
    return darkMode;
};
exports.default = usePreferDarkMode;
